<mat-toolbar class="custom-header">
  <span (click)="closeModal()">
    <mat-icon svgIcon="mat:arrow_back"></mat-icon>
  </span>
</mat-toolbar>

<div class="container">
  <div class="program-card">
    <img [src]="environment + '/' + program.id + '/images/main'" alt="Program image" />
  </div>

  <div class="info-box">
    <p class="data-label">{{ "PROGRAM-DETAIL.WEEK-NUMBER" | translate }}</p>
    <p class="data">{{ program.numberOfWeeks }}</p>
  </div>

  <div class="info-box">
    <p class="data-label">{{ "PROGRAM-DETAIL.WEEKLY-WORKOUTS" | translate }}</p>
    <p class="data">{{ program.weeklyWorkouts }}</p>
  </div>

  <div class="info-box">
    <p class="data-label">{{ "PROGRAM-DETAIL.WORKOUT-DURATION" | translate }}</p>
    <p class="data">{{ program.workoutDurationInMinutes }}</p>
  </div>

  <h2>{{ "PROGRAM-DETAIL.ABOUT" | translate }}</h2>
  <p class="description">
    {{ program.i18nDescription[translate.currentLang.toUpperCase()] }}
  </p>

<div class="footer-position">
    <button class="its-button select-program-btn" *ngIf="!spinner" [disabled]="program.id === guiService?.userLogged?.workoutInfo?.currentProgram" (click)="changeProgram()">{{"PROGRAM-DETAIL.SELECT" | translate}}</button>
    <button class="its-button select-program-btn" style="text-align: center;" *ngIf="spinner"><mat-spinner  diameter="20"></mat-spinner></button>
  </div>
</div>
